import Anonymous from '../../../icons/Anonymous';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';

interface CommentAuthorAvatarProps {
  anonymous?: boolean;
  thumbnailUrl?: string;
  size?: number;
}

export const CommentAuthorAvatar = ({
  anonymous,
  thumbnailUrl,
  size = 34
}: CommentAuthorAvatarProps) => {
  if (anonymous) return <Anonymous size={size} />;
  return <ProfileAvatar thumbnailUrl={thumbnailUrl} widthAndHeight={`${size}px`} />;
};
